var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.countryCode)?_c('img',{staticClass:"country-flag",attrs:{"alt":`${_vm.countryLabel} Flag`,"src":`https://www.countryflags.io/${_vm.countryCode}/${_vm.finish}/${_vm.size}.png`}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }